<template>
<div class="page page_adress">
    <div class="list">
        <div class="item" v-for="(item,index) in dataList" :key="index">
            <div class="item_top" @click="selectAddress(item)">
                <div class="user">
                    <span class="name">{{ item.person }} </span>
                    <span class="phone"> {{ item.phone ? (item.phone).replace((item.phone).substring(3,7),'****') : ''}}</span>
                    <span class="adressDefault" v-if="canSelect==1&&item.default==1">默认</span>
                </div>
                <div class="adress">
					<span>{{item.area_name1}}</span>
					<span>{{item.area_name2}}</span>
					<span>{{item.area_name3}}</span>
					<span>{{item.address}}</span>
					<!-- <span>{{ item.area_name1+item.area_name2+item.area_name3+item.address }}</span> -->
				</div>
            </div>
            <div class="item_bottom">
                <div v-if="canSelect!=1" :class="item.default ? 'default':'default_un'" @click="setDefaultAddress(item)"><span class="txt">默认地址</span></div>
                <div v-else :class="item.isSelect ? 'default':'default_un'" @click="selectAddress(item)"></div>
                <div class="actions clearfix">
                    <div class="action f-l" @click="editAddress(item)">编辑</div>
                    <div v-if="canSelect!=1" class="action f-l" @click="deleteAddress(item)">删除</div>
                </div>
            </div>
        </div>
    </div>
    <!-- 新建收货地址 -->
    <div class="bottom">
        <div class="action_add" @click="addAdress">+新建收货地址</div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SELECTADDRESS
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
            canSelect: this.$route.query.canSelect,
            addressId: this.$route.query.addressId,
            publicPath: process.env.BASE_URL,
            pages: {
                page: 1,
                size: 10
            },
            dataList: [],
            token: null
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '收货地址'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                this.getData()
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
        }
        // 获取列表
        // this.getData();
    },
    mounted() {
        this.getData();
    },
    methods: {
        // 获取列表
        getData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token,
                page: 1,
                size: 30
            }
            console.log(params)
            this.$api.address.addressList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result
                    if (this.canSelect == 1) {
                        for (let i = 0; i < list.length; i++) {
                            var address = list[i];
                            if (address.address_id == this.addressId) {
                                address.isSelect = true
                            } else {
                                address.isSelect = false
                            }
                            list[i] = address
                        }
                    }
                    console.log('list',list)
                    this.dataList = list
                } else {
                    this.$toast(res.message)
                }
            })
        },
        selectAddress(item) {
            if (this.canSelect == 1) {
                var data = {
                    'address_id': item.address_id,
                    'address_person': item.person,
                    'address_phone': item.phone,
                    'address': item.area_name1 + item.area_name2 + item.area_name3 + item.address,
                    'is_default': item.default
                }
                this.$store.commit(SELECTADDRESS, {
                    select_address: JSON.stringify(data)
				});
				this.$router.back()
            }
        },
        deleteAddress(item) {
            var params = {
                token: this.token,
                address_id: item.address_id,
            }
            this.$api.address.deleteAddress(params).then(res => {
                if (res.code == 200) {
                    this.$toast(res.message)
                    this.getData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        setDefaultAddress(item) {
			let defaultVal = item.default == 1? 0: 1;
            var params = {
                token: this.token,
                address_id: item.address_id,
                person: item.person,
                phone: item.phone,
                address: item.address,
                area_name1: item.area_code1,
                area_name2: item.area_code2,
                area_name3: item.area_code3,
                default: defaultVal,
            }
            console.log(params)
            this.$api.address.editAddress(params).then(res => {
                if (res.code == 200) {
                    this.$toast(res.message);
                    this.getData()
                } else {
                    this.$toast(res.message)
                }
            })
        },
        editAddress(item) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/user/adressAdd?addressId=' + item.address_id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/user/adressAdd',
                    query: {
                        addressId: item.address_id
                    }
                })
            }
        },
        // 新增收货地址
        addAdress() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/user/adressAdd'
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    name: 'add-adress'
                })
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
